import Axios from './axios_wrapper'

export function getLocales() {
  return Axios({
    url: `/locales`
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/locales.js
// module id = null
// module chunks = 